import type { CmpHider } from './types';

export const complianz: CmpHider = {
  id: 'complianz',
  label: 'Complianz',
  css: `
      /* Complianz (complianz.io, WordPress/Shopify GDPR/CCPA plugin): the consent
         UI uses the "cmplz-" namespace. The banner markup lives inside the wrapper
         "#cmplz-cookiebanner-container", with the visible card in ".cmplz-cookiebanner"
         (position:fixed, z-index 99999) — bottom-corner banners show no backdrop, but
         the center/popup banner styles add a fixed full-screen dimmer in ".cmplz-overlay",
         which we hide defensively. After consent (or in the "view-preferences" state) a
         persistent fixed revoke button ".cmplz-manage-consent" (z-index 9998) stays on
         screen; we hide that too. Hiding the container and the banner/overlay/button
         classes removes the whole consent UI. The "cmplz-" hooks are specific to
         Complianz, so this does not touch unrelated page content. Complianz does not
         lock page scroll via a body class or inline style on the sites observed; if a
         build does, the html/html-body [style*="overflow"] and [style*="position:
         fixed"] release rules above already out-specify an inline overflow/position
         lock. */
      #cmplz-cookiebanner-container,
      .cmplz-cookiebanner,
      .cmplz-overlay,
      .cmplz-manage-consent { display: none !important; }
  `,
};
